import { Link } from 'gatsby';
import React from 'react';
import {
  InstagramLogo,
  FacebookLogo,
  Envelope,
  TelegramLogo,
  WhatsappLogo,
  List,
  X,
} from '@phosphor-icons/react';
import clsx from 'clsx';
import { sendWhatsapp } from '../utils/whatsapp';
import SocialLink from './SocialLink';

const navlinks = [
  {
    name: 'Beranda',
    link: '/',
  },
  {
    name: 'Paket Internet',
    link: '/#packages',
  },
  {
    name: 'Tentang Kami',
    link: '/#about',
  },
  {
    name: 'Karir',
    link: '/career',
  },
];

const NavbarComponent = () => {
  const [active, setActive] = React.useState<string>('Beranda');
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <>
      <div className="container">
        <SocialLink />
      </div>
      <nav className="w-full font-medium sticky top-0 z-10 bg-white/70 backdrop-blur-xl border-b border-white/20 shadow-[inset_0_-1px_0_rgba(255,255,255,0.2)] py-3">
        <div className="container">
          <div className="w-full flex items-center justify-center lg:justify-between py-3 relative">
            <div className="flex flex-col items-end gap-2 lg:hidden absolute right-5 top-3">
              <button onClick={() => setOpen(!open)}>
                {open ? <X size={24} /> : <List size={24} />}
              </button>
              {open && (
                <div className="bg-white py-5 px-3 shadow-md rounded-md">
                  <ul className="flex flex-col gap-5 items-center justify-center">
                    {navlinks.map((data, index) => (
                      <Link
                        key={index}
                        to={data.link}
                        onClick={() => setActive(data.name)}
                        className={clsx(
                          'px-5 py-1.5 text-center rounded-full transition-all duration-300 active:scale-[0.98]',
                          active === data.name
                            ? 'bg-secondary text-gray-900 font-semibold shadow-sm'
                            : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50',
                        )}
                      >
                        {data.name}
                      </Link>
                    ))}
                    <div className="flex flex-col gap-2 w-full">
                      <a
                        target="_blank"
                        className="w-full text-center px-4 py-2 border border-primary/20 hover:border-primary/40 bg-white transition-all duration-300 active:scale-[0.98] text-primary rounded-full font-semibold outline-none focus:ring-2 focus:ring-primary/20"
                        href="https:///ebilling.intanet.id"
                      >
                        LOGIN
                      </a>
                      <a
                        target="_blank"
                        className="w-full text-center px-4 py-2 bg-primary hover:bg-primary/90 transition-all duration-300 active:scale-[0.98] shadow-[0_8px_16px_-6px_rgba(14,165,233,0.3)] text-white rounded-full font-semibold outline-none focus:ring-2 focus:ring-primary/20"
                        href={sendWhatsapp(
                          'Halo INTANET, saya mau pasang internet di rumah. Bisa cek area saya?',
                        )}
                      >
                        DAFTAR
                      </a>
                    </div>
                  </ul>
                </div>
              )}
            </div>
            <Link to="/">
              <img
                src={'/images/intanet-text.png'}
                alt="logo-intanet"
                className="w-40"
              />
            </Link>
            <div className="ml-10 lg:flex gap-10 hidden">
              <ul className="flex gap-5 items-center">
                {navlinks.map((data, index) => (
                  <Link
                    key={index}
                    to={data.link}
                    onClick={() => setActive(data.name)}
                    className={clsx(
                      'px-5 py-1.5 text-center rounded-full transition-all duration-300 active:scale-[0.98]',
                      active === data.name
                        ? 'bg-secondary text-gray-900 font-semibold shadow-sm'
                        : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50',
                    )}
                  >
                    {data.name}
                  </Link>
                ))}
              </ul>
              <div className="flex flex-row gap-2">
                <a
                  target="_blank"
                  className="px-6 py-2 border border-primary/20 hover:border-primary/40 bg-white transition-all duration-300 active:scale-[0.98] text-primary rounded-full font-semibold outline-none focus:ring-2 focus:ring-primary/20"
                  href="https://ebilling.intanet.id/"
                >
                  LOGIN
                </a>
                <a
                  target="_blank"
                  className="px-6 py-2 bg-primary hover:bg-primary/90 transition-all duration-300 active:scale-[0.98] shadow-[0_8px_16px_-6px_rgba(14,165,233,0.3)] text-white rounded-full font-semibold outline-none focus:ring-2 focus:ring-primary/20"
                  href={sendWhatsapp(
                    'Halo INTANET, saya mau pasang internet di rumah. Bisa cek area saya?',
                  )}
                >
                  DAFTAR
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarComponent;
